import { titulosApi } from "../view/titulos.service";

export const getTituloStatus = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    getTituloStatus: builder.query({
      query: (id) => ({
        url: `/v1/api/titulo/${id}/status/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Titulos", id }],
    }),
  }),
});

export const { useGetTituloStatusQuery, useLazyGetTituloStatusQuery } = getTituloStatus;
